(function () {
  'use strict';
  function carousel(root, track) {
    // Match the existing homepage rails: 4.5s on desktop, manual on mobile.
    if (!root.classList.contains('mi-hs-products--rail') || root.__miHsCarousel) return;
    var mobile = window.matchMedia('(max-width: 809px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var timer = null;
    var visible = !window.IntersectionObserver;
    var hovering = false;
    var dragging = false;
    var resumeAt = 0;
    var cleanup = [];
    var heightFrame = null;
    var windowWidth = window.innerWidth;
    var mobileRows = [
      ['title', '.framer-17ex6ke, .mi-hs-preview-card h4'],
      ['rating', '.framer-nmyrpr'],
      ['price', '.mi-card__precios, .mi-hs-preview-card__price'],
      ['addi', '.mi-card__addi'],
      ['sizes', '[data-mi-tallas], .mi-hs-preview-card__size']
    ];
    var sizeObserver = window.ResizeObserver ? new ResizeObserver(queueHeight) : null;
    function fitHeight() {
      heightFrame = null;
      if (!root.isConnected || !track.clientWidth) return;
      // Keep restored/bounced iOS scroll positions on the horizontal axis only.
      if (track.scrollTop) track.scrollTop = 0;
      var viewport = track.getBoundingClientRect();
      mobileRows.forEach(function (row) { track.style.removeProperty('--mi-hs-mobile-' + row[0]); });
      var tallest = 0;
      Array.from(track.children).forEach(function (item) {
        var bounds = item.getBoundingClientRect();
        if (mobile.matches || (bounds.right > viewport.left + 1 && bounds.left < viewport.right - 1)) {
          tallest = Math.max(tallest, bounds.height);
        }
      });
      if (!tallest) return;
      var style = window.getComputedStyle(track);
      var height = Math.ceil(tallest + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
      if (track.style.height !== height + 'px') track.style.height = height + 'px';
    }
    function nativeMobileRows() {
      return mobile.matches && window.CSS && CSS.supports('grid-template-rows', 'subgrid');
    }
    function queueHeight() {
      if (nativeMobileRows()) return;
      if (heightFrame === null) heightFrame = window.requestAnimationFrame(fitHeight);
    }
    function observeSizes() {
      if (nativeMobileRows()) {
        window.cancelAnimationFrame(heightFrame); heightFrame = null;
        mobileRows.forEach(function (row) { track.style.removeProperty('--mi-hs-mobile-' + row[0]); });
        track.style.height = '';
      }
      if (sizeObserver) {
        sizeObserver.disconnect();
        if (!nativeMobileRows()) Array.from(track.children).forEach(function (item) { sizeObserver.observe(item); });
      }
      queueHeight();
    }
    function scrolled() {
      // Intrinsic mobile rows stay stable, including during touch inertia.
      if (!mobile.matches) queueHeight();
    }
    function resized() {
      // Safari's toolbar animates height during vertical scrolling. The
      // approved mobile rails ignore these events; Hot Sale must do so too.
      if (mobile.matches && window.innerWidth === windowWidth) return;
      windowWidth = window.innerWidth;
      observeSizes(); schedule();
    }
    function listen(target, event, callback, options) {
      target.addEventListener(event, callback, options);
      cleanup.push(function () { target.removeEventListener(event, callback, options); });
    }
    function stop() { window.clearTimeout(timer); timer = null; }
    function allowed() {
      return root.isConnected && visible && !mobile.matches && !reduced.matches &&
        !document.hidden && !hovering && !dragging && !root.contains(document.activeElement) &&
        window.miHotSale && window.miHotSale.active && track.scrollWidth > track.clientWidth + 2;
    }
    function schedule() {
      stop();
      if (!root.isConnected) { destroy(); return; }
      if (allowed()) timer = window.setTimeout(advance, Math.max(4500, resumeAt - Date.now()));
    }
    function advance() {
      timer = null;
      if (!allowed()) return;
      var items = track.children;
      var step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 0;
      var end = track.scrollWidth - track.clientWidth;
      if (step > 0) {
        var next = track.scrollLeft >= end - 2 ? 0 : Math.min((Math.round(track.scrollLeft / step) + 1) * step, end);
        track.scrollTo({ left: next, behavior: 'smooth' });
      }
      schedule();
    }
    function rest() { resumeAt = Date.now() + 8000; schedule(); }
    function release() { if (dragging) { dragging = false; rest(); } }
    function destroy() {
      stop();
      window.cancelAnimationFrame(heightFrame);
      if (sizeObserver) sizeObserver.disconnect();
      if (itemsObserver) itemsObserver.disconnect();
      track.style.height = '';
      cleanup.forEach(function (remove) { remove(); });
      cleanup = [];
      if (observer) observer.disconnect();
      delete root.__miHsCarousel;
    }
    root.__miHsCarousel = { refresh: function () { observeSizes(); schedule(); }, destroy: destroy };
    listen(track, 'scroll', scrolled, { passive: true });
    listen(window, 'resize', resized, { passive: true });
    listen(document, 'mi-hot-sale-change', queueHeight);
    var itemsObserver = window.MutationObserver ? new MutationObserver(observeSizes) : null;
    if (itemsObserver) itemsObserver.observe(track, { childList: true });
    observeSizes();
    listen(root, 'pointerenter', function (event) { if (event.pointerType !== 'touch') { hovering = true; stop(); } });
    listen(root, 'pointerleave', function () { hovering = false; schedule(); });
    listen(root, 'pointerdown', function () { dragging = true; stop(); }, { passive: true });
    listen(window, 'pointerup', release, { passive: true });
    listen(window, 'pointercancel', release, { passive: true });
    listen(root, 'click', function () { rest(); queueHeight(); });
    listen(root, 'keydown', rest);
    listen(root, 'wheel', rest, { passive: true });
    listen(root, 'focusin', stop);
    listen(root, 'focusout', schedule);
    listen(document, 'visibilitychange', schedule);
    listen(document, 'mi-hot-sale-change', schedule);
    listen(mobile, 'change', function () { observeSizes(); schedule(); });
    listen(reduced, 'change', schedule);
    if (document.fonts) {
      document.fonts.ready.then(queueHeight);
      listen(document.fonts, 'loadingdone', queueHeight);
    }
    listen(document, 'shopify:section:unload', function (event) { if (event.target.contains(root)) destroy(); });
    var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      schedule();
    }, { threshold: 0.15 }) : null;
    if (observer) observer.observe(root);
    schedule();
  }
  function init(scope) {
    scope.querySelectorAll('[data-mi-hs-products]').forEach(function (root) {
      var track = root.querySelector('[data-mi-hs-track]');
      if (!track) return;
      carousel(root, track);
      root.querySelectorAll('[data-mi-hs-step]').forEach(function (button) {
        if (button.dataset.miHsBound) return;
        button.dataset.miHsBound = 'true';
        button.addEventListener('click', function () {
          var items = track.children;
          var step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
          var count = window.matchMedia('(max-width: 809px)').matches ? 2 : 4;
          track.scrollBy({ left: Number(button.dataset.miHsStep) * step * count, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('mi-hot-sale-change', function () { init(document); });
  window.addEventListener('online', function () { init(document); });
})();
